export default "__VITE_ASSET__fHl2ug6n__"